import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ManagerPinPad } from '@/components/ManagerPinPad';
export function ChecklistPinDialog({ open, mode, taskTitle, itemLabel, onClose, onSubmit }) {
    const [note, setNote] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [padKey, setPadKey] = useState(0);
    useEffect(() => {
        if (open) {
            setNote('');
            setError(null);
            setLoading(false);
            setPadKey((k) => k + 1);
        }
    }, [open]);
    const handleSubmit = async (pin) => {
        setLoading(true);
        setError(null);
        try {
            await onSubmit(pin, note.trim());
            onClose();
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Something went wrong');
            setPadKey((k) => k + 1); // clear the PIN for another try
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx(Dialog, { open: open, onOpenChange: (o) => { if (!o && !loading)
            onClose(); }, children: _jsxs(DialogContent, { className: "bg-slate-800 border-slate-700 text-white sm:max-w-sm", "data-testid": "checklist-pin-dialog", 
            // Keep focus off the note box so typed digits go to the PIN pad.
            onOpenAutoFocus: (e) => e.preventDefault(), children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: mode === 'complete' ? 'Check off task' : 'Undo check' }), _jsxs(DialogDescription, { className: "text-slate-400", children: [_jsx("span", { className: "text-white font-medium", children: taskTitle }), itemLabel ? _jsxs("span", { className: "text-slate-400", children: [" \u00B7 ", itemLabel] }) : null] })] }), mode === 'complete' && (_jsxs("div", { children: [_jsx("label", { htmlFor: "checklist-note", className: "text-xs text-slate-400", children: "Note (optional)" }), _jsx("input", { id: "checklist-note", "data-testid": "checklist-note", value: note, onChange: (e) => setNote(e.target.value), maxLength: 300, placeholder: "e.g. towels running low", className: "mt-1 w-full rounded-md bg-slate-900 border border-slate-600 px-3 py-2 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:ring-1 focus:ring-amber-400" })] })), _jsx(ManagerPinPad, { onSubmit: (pin) => handleSubmit(pin), error: error, loading: loading, prompt: mode === 'complete' ? 'Enter your PIN to sign off' : 'Enter your PIN (or a manager PIN) to undo', submitLabel: mode === 'complete' ? 'Done ✓' : 'Undo', loadingLabel: "Saving...", showRemember: false }, padKey)] }) }));
}
